"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CAStateRegionMapping = {
    Alberta: 'Western Canada',
    'British Columbia': 'Western Canada',
    Manitoba: 'Western Canada',
    Saskatchewan: 'Western Canada',
    'Newfoundland and Labrador': 'Eastern Canada',
    'New Brunswick': 'Eastern Canada',
    'Nova Scotia': 'Eastern Canada',
    Ontario: 'Eastern Canada',
    Quebec: 'Eastern Canada',
    'Prince Edward Island': 'Eastern Canada',
    Nunavut: 'Northern Canada',
    Yukon: 'Northern Canada',
};
exports.default = CAStateRegionMapping;
